import { SpinnerCog } from "../../../themes/icons/SpinnerCog";
import styles from "./Spinner.module.scss";

function Spinner({ message }) {
  return (
    <div className={styles["background"]}>
      <div className={styles["foreground"]}>
        <div className={styles["foreground__spinner"]}>
          <SpinnerCog />
        </div>
        <div className={styles["foreground__message"]}>{message}</div>
      </div>
    </div>
  );
}

export default Spinner;
